import type { FC } from 'react';

import { SIPLogoLink } from '@/components/common/SIPLogoLink';
import { ConfiguratorLabel } from '@/components/toolbar/ConfiguratorLabel';

/**
 * The header's brand lockup: the SIP logo link followed by the static
 * Konfigurator label, read as one unit. Shared by the live {@link Header} and
 * the static {@link ToolbarFallback} so the two bars cannot drift apart again
 * (they once disagreed on the trademark colour, fe-monorepo-2k7x).
 *
 * Layout mirrors the Partner Portal's lockup one to one (`items-end gap-1`, the
 * label lifted `3px` to sit on the wordmark's baseline above the link's focus
 * padding) so the two SIP apps read as one brand. Change both together.
 */
export const BrandLockup: FC = () => (
  <div className="flex items-end gap-1">
    <SIPLogoLink className="text-primary" />
    <ConfiguratorLabel />
  </div>
);
